import { ButtonHTMLAttributes, forwardRef } from "react";
import { mergeClass } from "../utils/mergeClass";

export type CleButtonVariant =
  "default" | "destructive" | "outline" | "secondary" | "ghost" | "link";

export type CleButtonSize = "default" | "sm" | "xs" | "lg" | "icon";

export type CleButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  size?: CleButtonSize;
  variant?: CleButtonVariant;
};

const CleButton = forwardRef<HTMLButtonElement, CleButtonProps>(
  (
    {
      children,
      className,
      size = "default",
      type = "button",
      variant = "default",
      ...rest
    },
    ref,
  ) => {
    return (
      <button
        ref={ref}
        type={type}
        className={mergeClass(
          "cle-button",
          `cle-button--variant-${variant}`,
          `cle-button--size-${size}`,
          className,
        )}
        {...rest}
      >
        {children}
      </button>
    );
  },
);

CleButton.displayName = "CleButton";

export default CleButton;
